import { render } from "./PlaceEditPage.vue?vue&type=template&id=130476f0&scoped=true"
import script from "./PlaceEditPage.vue?vue&type=script&lang=js"
export * from "./PlaceEditPage.vue?vue&type=script&lang=js"

import "./PlaceEditPage.vue?vue&type=style&index=0&id=130476f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130476f0"]])

export default __exports__